import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ABAS_DE_CADASTRO } from '@/features/cadastros/abas';
import { CadastrosDeApoio } from '@/features/cadastros/componentes/CadastrosDeApoio';
import { rotaDeTela } from '@/features/permissoes/guardas';

const busca = z.object({
  aba: z.enum(ABAS_DE_CADASTRO).catch('tipos-atendimento'),
  busca: z.string().optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
  tags: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_autenticado/cadastros/')({
  ...rotaDeTela('cadastros.apoio'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const { aba, busca: texto, cursor, tags } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CadastrosDeApoio
      aba={aba}
      filtros={{ busca: texto, cursor, tags }}
      aoMudarAba={(nova) => {
        void navigate({ search: { aba: nova } });
      }}
      aoMudarFiltros={(filtros) => {
        void navigate({ search: (atual) => ({ ...atual, ...filtros }), replace: true });
      }}
    />
  );
}
